const serviceConfig = window.drupalSettings?.tdsServiceConfig ?? {};

/**
 * @typedef Service
 * @type {object}
 * @property {string} url
 * @property {string} [accessToken]
 * @property {string} [refreshToken]
 */

/**
 * Resolve attributes needed to make a client side call to one of our services
 * @param {string} serviceName
 * @returns Service
 */
export function resolveService(serviceName) {
  return serviceConfig[serviceName] ?? {};
}
